import React from 'react';
import RecipeCard from '../Recipe Card';
import './styles.sass';

const List = ({ recipes, setShowRecipe }) => {
    return (
        <div className="list-container">
            {recipes.map((recipe) => {
                return (
                    <RecipeCard
                        key={recipe.id}
                        recipe={recipe}
                        setShowRecipe={setShowRecipe}
                    />
                )
            })}
        </div>
    )
}

export default List;